import React, { useEffect } from 'react';
import ProductPartsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/ProductPartsList';
import ProductPartsListComponent from '../../Components/ProductPartsList/ProductPartsList';
import memoize from '@configuratorware/configurator-frontendgui/Utils/Function/memoize';
import * as configuratorActions from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

const ProductPartsList = (props) => {
  const dispatch = useDispatch();
  const configurator = useSelector((state) => state.configurator);
  const removeHiddenComponents = memoize((components) =>
    components.filter(({ hiddenInFrontend }) => !hiddenInFrontend)
  );
  const optionClassification = removeHiddenComponents(configurator.filteredOptionclassifications);
  useEffect(() => {
    if (optionClassification.length > 0 && isEmpty(configurator.selectedoptionclassification)) {
      props.onSelect(optionClassification[0]);
    }
  }, [optionClassification]);

  return (
    <ProductPartsListContainer
      {...props}
      Component={ProductPartsListComponent}
      onSelectOption={(option) =>
        dispatch(
          configuratorActions.selectOption(option, false, false, configurator.selectedoptionclassification)
        )
      }
      selectedOption={get(configurator, 'selectedoptionclassification.selectedoptions[0]', null)}
      options={get(configurator, 'options', [])}
      colorFilterItems={get(configurator, 'colorFilterItems', [])}
    />
  );
};

export default ProductPartsList;
